import { FC, ReactNode } from 'react';
import styles from './index.module.scss';

/**
 * ConditionsAreaWrapperコンポーネントのProps
 */
interface Props {
  /** 子要素 */
  children: ReactNode;
}

/**
 * ConditionsAreaWrapper
 * 検索条件を表示するエリアのラッパーコンポーネント
 *
 * @param {Props} props コンポーネントのプロパティ
 * @returns {JSX.Element}
 */
export const ConditionsAreaWrapper: FC<Props> = ({ children }) => {
  return <div className={styles['conditions-area-wrapper']}>{children}</div>;
};
